import { CONTAINS, EQUALS, IS_NONE, ONE_OF } from '../../../../../../operators';

export const operatorLabels = {
    [EQUALS]: 'is equal to',
    [CONTAINS]: 'contains',
    [IS_NONE]: 'is none',
    [ONE_OF]: 'is one of',
};
